import { CONTRACT_TABLE_COLUMNS } from "@/constants/contract_table_columns";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  searchResult: undefined,
  consultants: undefined,
  financialSolutions: undefined,
  financialSolutionFields: undefined,
  financialSolutionCalculationRules: {},
  statusList: [],
  editContractSidebar: {
    id: undefined,
    proposal_number: undefined,
    id_contract_status: undefined,
    financial_solution_id: undefined,
    // Veredito do fechamento de competência vindo do servidor (`status_only` trava as datas).
    edit_mode: undefined,
    allowed_status_ids: undefined,
    visible: false,
    currentPage: undefined,
    saveAction: undefined,
  },
  addReceiptSidebar: {
    id: undefined,
    visible: false,
    currentPage: undefined,
    saveAction: undefined,
  },
  requestDeletionSidebar: {
    id: undefined,
    description: undefined,
    currentPage: undefined,
    contract_id: undefined,
  },
  // Passo 1 da alteração extraordinária: coleta só a justificativa. `proceed` recebe o
  // `exception_id` devolvido pela API e dispara a mutação real (passo 2).
  extraordinaryChangeSidebar: {
    id: undefined,
    competence: undefined,
    lock_reason: undefined,
    changes: undefined,
    visible: false,
    proceed: undefined,
  },
  editSnapshotSidebar: {
    id: undefined,
    consultant_id: undefined,
    visible: false,
  },
  details: {
    generalInformation: undefined,
  },
  comments: undefined,
  payments: undefined,
  commissions: undefined,
  files: undefined,
  history: undefined,
  deletionRequestSearchResult: undefined,
  requestDeletionAprovalSidebar: false,
  customerAppointments: [],
  editContractOwnerSidebar: {
    id: undefined,
    visible: false,
    saveAction: undefined
  },
  queryAsaasIdSidebar: {
    visible: false
  },
  transactions: [],
  saveTransactionSidebar: {
    id: undefined,
    visible: false,
    saveAction: undefined
  },
  pixInstallmentPlans: [],
  // As colunas vivem na store para que HIDE_COLUMNS aplique a preferência do usuário.
  //
  // tdClass/thClass nascem declaradas de propósito: HIDE_COLUMNS atribui essas duas
  // chaves, e no Vue 2 propriedade criada depois não é reativa.
  tableColumns: CONTRACT_TABLE_COLUMNS.map(column => ({
    ...column,
    tdClass: '',
    thClass: '',
  })),
  settingsTableContracts: undefined,
  settingsTableSidebar: {
    visible: false,
  },
};

export default {
  state,
  actions,
  getters,
  mutations,
};
